import { mergeStickyBannerConfig } from "./commonConfig";
import { BEHAVIOR_MODES, STICKY_PAGE_TYPES } from "./stickyBannerConfig.types";

/**
 * Exam landing — single static message (no score matrix, milestones, or carousel).
 */
export const examPageStickyBannerConfig = mergeStickyBannerConfig({
  id: "exam-page",
  pageType: STICKY_PAGE_TYPES.EXAM,
  behaviorMode: BEHAVIOR_MODES.CONDITIONS,
  defaultMessageId: "exam.results.guidance",
  defaultCtaText: "Talk to an Expert",
  carouselIntervalMs: 4000,
  scrollTriggers: [],
  scrollMilestones: [],
  messageRules: [],
  carouselMessageIds: []
});
